const en = {
  'loginId.title': 'loginId',
};

export default en;
